export default __webpack_public_path__ + "static/media/cloud2.d30b116b.png";